import * as React from 'react';
import Form from 'antd/lib/form';
import { IAccount, IAccountForm, IBranchAction } from '../../Models/Account';
import Icon from 'antd/lib/icon';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import { ISelectorData } from '../../Components/Selector';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Producer, Branch, IFaena } from '../../Models/Report';
import Select from 'antd/lib/select';
import './FormAccount.scss';
import Button from 'antd/lib/button';
import { IProfile } from '../../Models/Security';
import BranchList from './BranchList';
import SelectorProducer from './SelectorProducer';
import Loading from '../../Components/Loading';
import Dialog from '../../Components/Dialog';
import { searchEmail } from '../../Utils/UtilsAccount'
import { EStatusRequest } from '../../Reducers/Session';

export interface IAccountFormProps extends RouteComponentProps {
	producers: Producer[];
	profiles: IProfile[];
	isEdit?: boolean;
	current?: IAccount;
	form: WrappedFormUtils;
	isRequest: boolean;
	status: EStatusRequest;
	message: string | any;
	onCleanStatus: () => void;
	onCleanCurrent?: () => void;
	onSend: (data: IAccountForm, id?: number) => void;
}

const AccountForm = (props: IAccountFormProps) => {
	// eslint-disable-next-line
	const [cancel, setCancel] = React.useState(false);
	const [selected, setSelected] = React.useState([] as string[]);
	const [branchs, setBranchs] = React.useState({} as any);
	const [isLoadData, setLoadData] = React.useState(false);
	const { getFieldDecorator, setFieldsValue } = props.form;
	const message = !props.isEdit
		? 'Crear nueva cuenta de usuario'
		: `Editando cuenta de ${props.current!.name}`;
	const producersSelectorData = props.producers.map(
		p => ({ label: p.name.toUpperCase(), value: p.id } as ISelectorData)
	);
	const [current, setCurrent] = React.useState<IAccount | undefined>(props.current);
	const onSelectedProducer = (value: string[]) => {
		setSelected(value);
		if (value) {
			const branchNew: any = {};
			for (let i = 0; i < value.length; i += 1) {
				const key = value[i];
				branchNew[key] = branchs[key];
			}
			setBranchs(branchNew);
		}
	};
	const onDeSelectedProducer = (value: string) => {
		if (value) {
			const branchNew: any = {...branchs};
			delete branchNew[value];
			if (current && current!.producers) {
				const producers = [];
				for (let i = 0; i < current!.producers!.length; i += 1) {
					// eslint-disable-next-line
					if (current.producers![i].id != value) {
						producers.push(current.producers![i]);
					}
				}
				const newCurrent = {...current, producers: producers};
				setCurrent(newCurrent);
			}
			setBranchs(branchNew);
		}
	};
	const onSelectBranch = (producer: Producer, list: Branch[]) => {
		const res = { ...branchs } as any;
		res[producer.id] = list;
		setBranchs(res);
		setFieldsValue({
			producers: selected
		});
	};
	const onSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
		evt.preventDefault();
		props.form.validateFields((errs, data) => {
			if (errs || props.isRequest) {
				return;
			}
			const dataSend = { ...data };
			delete dataSend.producers;
			const getBranchsToAdd = () => {
				const res: IBranchAction[] = [];
				const producersRut = Object.keys(branchs);
				for (let i = 0; i < producersRut.length; i += 1) {
					const rut = producersRut[i];
					const list = branchs[rut];
					if (list) {
						for (let j = 0; j < list.length; j += 1) {
							res.push({
								permiso: 'S',
								rutProductor: rut,
								sucursal: list[j].id,
								username:
									current ? current.id.toString() : '-1'
							});
						}
					}
				}
				return res;
			};
			const getBranchsToDel = (data: any) => {
				const list: IFaena[] = current!.producersList!.filter(
					(p: IFaena) =>
						data.brandsAdd.find(
							(b: IBranchAction) =>
							// eslint-disable-next-line
								b.sucursal == p.dcSucursal && b.rutProductor == p.dcRutProductor
						) == null
				);
				return list.map(l => ({
					permiso: 'N',
					rutProductor: l.dcRutProductor,
					sucursal: l.dcSucursal,
					username: current!.id.toString()
				}));
			};

			dataSend.brandsAdd = getBranchsToAdd();
			dataSend.QuantityBranch = dataSend.brandsAdd.length;
			if (current) {
				dataSend.id = current!.id;
				dataSend.brandsDel = getBranchsToDel(dataSend);
				dataSend.brandsAdd = dataSend.brandsAdd.filter(
					(b: IBranchAction) =>
						current!.producersList!.find(
							f =>
							// eslint-disable-next-line
								f.dcSucursal == b.sucursal && f.dcRutProductor == b.rutProductor
						) == null
				);
			}
			props.onSend(dataSend, current ? current.id : undefined);
		});
	};

	const getProducersSelected = () => {
		const res = {} as any;
		if (!current) {
			return false;
		}
		const producers = current!.producers!;
		for (let i = 0; i < producers.length; i += 1) {
			const producer = producers[i];
			res[producer.id] = [];
			for (let j = 0; j < producer.branchs.length; j += 1) {
				res[producer.id].push(producer.branchs[j].id);
			}
		}
		return res;
	};
	// eslint-disable-next-line
	React.useEffect(() => {
		if (!isLoadData) {
			if (current) {
				const keys = current!.producers!.map(b => b.id);
				setSelected(keys);
				const selection = current!.producers!.reduce(
					(a: any, c: any) => {
						a[c.id] = c.branchs;
						return a;
					},
					{} as any
				);
				if (current!.producers!.length > 0) {
					setBranchs(selection);
					setFieldsValue({
						producers: selection
					});
				}
			}
			setLoadData(true);
		}
	});
	const onClose = () => {
		props.onCleanStatus();
		if (current) {
			const onCleanCurrent  = props.onCleanCurrent || (() => {});
			onCleanCurrent();
		}
		if (props.status !== EStatusRequest.FAIL) {
			props.history.push('/administration');
		}

	}
	const renderModal = () => {
		const isError = props.status === EStatusRequest.FAIL;
		const open = props.status === EStatusRequest.COMPLETE || isError;
		let message = 'Ha finalizado con éxito la operación';
		let extra = '';
		let operation = props.isEdit ? 'Editar Usuario' : 'Crear Usuario';
		if (cancel) {
			message = 'Ha cancelado la operación';
			extra = 'por lo tanto no se ha guardado ningún elemento.'
		}

		if (isError) {
			message = 'Ha ocurrido un error, intente nuevamente';
			if (props.message) {
				const err = props.message as any
				if (err && 'Detail' in err && err.Detail === 'DUPLICATE' ) {
					message = 'El correo enviado ya se encuentra registrado';
					operation = '';
				}
			}
		} else {
			if (cancel || open) {
				setTimeout(() => {
					onClose()
				}, 3000)
				}
		}
		return <Dialog open={cancel || open} onClose={onClose} >
			<h4>{message }<span>{operation}</span>{extra}</h4>
		</Dialog>
	}
	const isProcess = props.status === EStatusRequest.PROCESS;
	return (
		<Form onSubmit={onSubmit} className='FormAccount'>
			{isProcess ? <Loading /> : <span />}
			{renderModal()}
			<div style={{ display: isProcess ? 'none': 'block' }}>
			<h1>
				<Link className="arrow-return" to='/administration'>
					<Icon type='left' />
				</Link>
				{message}
			</h1>
			<div className='FormAccount-Content'>
				<h3>Descripción del usuario</h3>
				<div className='FormAccount-Content-Account'>
					<Form.Item label='Nombre'>
						{getFieldDecorator('name', {
							rules: [
								{
									required: true,
									message: '*El nombre es requerido'
								}
							],
							initialValue: current ? current.name : undefined
						})(<Input placeholder='Escriba el nombre (ej. Juan Perez)' />)}
					</Form.Item>
					<Row gutter={12} type='flex'>
						<Col>
							<Form.Item label='Correo'>
								{getFieldDecorator('username', {
									rules: [
										{
											required: true,
											message: '*El correo es requerido'
										},
										{
											type: 'email',
											message: 'Debe escribir un correo válido'
										},
										{
											message: 'Correo ya registrado',
											validator: searchEmail
										}
									],
									initialValue: current
										? current.username
										: undefined
								})(
									<Input placeholder='Escriba el correo (ej. usuario@puertoangamos.cl)' />
								)}
							</Form.Item>
						</Col>
						<Col>
							<Form.Item label='Asignar tipo de usuario'>
								{getFieldDecorator('idProfile', {
									rules: [
										{
											required: true,
											message: 'Seleccione un perfil'
										}
									],
									initialValue: current
										? current.idProfile
										: undefined
								})(
									<Select placeholder='Seleccionar un tipo de usuario'>
										{props.profiles.map(p => (
											<Select.Option key={p.id.toString()} value={p.id}>
												{p.description}
											</Select.Option>
										))}
									</Select>
								)}
							</Form.Item>
						</Col>
					</Row>
				</div>
				<hr style={{ margin: '10px -20px' }} />
				<h3>Asignación de empresas y faenas</h3>
				<div className='FormAccount-Content-Producer'>
					<Form.Item label='Empresas'>
						{getFieldDecorator('producers', {
							rules: [
								{
									required: true,
									message: 'Debe seleccionar al menos una empresa'
								}
							]
						})(
							<SelectorProducer
								onDeselected={onDeSelectedProducer}
								data={producersSelectorData}
								selected={selected}
								onSelected={onSelectedProducer}
							/>
						)}
					</Form.Item>
					<BranchList
						selectedRowKeys={getProducersSelected()}
						onSelected={onSelectBranch}
						selected={props.producers.filter(p => selected.indexOf(p.id) >= 0)}
					/>
				</div>
			</div>
				<Row
					className='FormAccount-Buttons'
					gutter={12}
					type='flex'
					justify='center'
					align='middle'>
					<Col>
						<Button htmlType='submit' type='danger'>
							{props.isEdit ? 'Guardar Cambios' :  'Crear Usuario'}
						</Button>
					</Col>
					<Col>
						<Button ghost type='danger' onClick={() => props.history.push('/administration')}>
							Cancelar
						</Button>
					</Col>
				</Row>
			</div>
		</Form>
	);
};

export default Form.create<IAccountFormProps>()(AccountForm);
